import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStencilCollapseGroups = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 8 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.88017 0.200478C6.14747 -0.0668261 6.58086 -0.0668261 6.84816 0.200478C7.11546 0.467783 7.11546 0.901168 6.84816 1.16847L4.0095 4.00713L3.5255 4.49113L3.04151 4.00713L0.202847 1.16847C-0.0644574 0.901168 -0.0644574 0.467783 0.202847 0.200478C0.470151 -0.0668261 0.903537 -0.0668261 1.17084 0.200478L3.5255 2.55514L5.88017 0.200478ZM1.16847 9.45851C0.901168 9.72582 0.467783 9.72582 0.200478 9.45851C-0.0668261 9.19121 -0.0668261 8.75782 0.200478 8.49052L3.03914 5.65186L3.52313 5.16786L4.00713 5.65186L6.84579 8.49052C7.1131 8.75782 7.1131 9.19121 6.84579 9.45851C6.57849 9.72582 6.1451 9.72582 5.8778 9.45851L3.52313 7.10385L1.16847 9.45851Z",
		fill: "currentColor"
	})
});
export default SvgStencilCollapseGroups;
